import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-confirm-send-to-first-aid-modal',
  templateUrl: './confirm-send-to-first-aid-modal.component.html',
  styleUrls: ['./confirm-send-to-first-aid-modal.component.scss']
})
export class ConfirmSendToFirstAidModalComponent {

  public data: any;
  endPoint: any;
  payload: any;
  firstAidForm!: FormGroup;
  submitted = false;
  isCommentBoxShow =false

  constructor(private toastr: ToastrService,private fb: FormBuilder, private api: SevaProfileService, protected dialogRef: NbDialogRef<any>) {
    this.data = this.dialogRef;
  }

  ngOnInit() {
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
    this.isCommentBoxShow = this.data.isCommentBoxShow; // Assuming this condition applies here
  
    this.initializeForm();
  }
  
  initializeForm() {
    const remarksValidators = this.isCommentBoxShow ? [] : [Validators.required]; // Conditional validators
    this.firstAidForm = this.fb.group({
      remarks: ['', remarksValidators],
    });
  }
  
  sendToFirstAid() {
    if (!this.isCommentBoxShow && this.firstAidForm.invalid) {
      this.submitted = true;
      this.firstAidForm.markAllAsTouched(); // Highlight invalid fields
      return;
    }
  
    this.submitted = false;
  
    if (!this.isCommentBoxShow) {
      const remarks = this.firstAidForm.get('remarks')?.value;
      this.payload.TaggedForFirstNotes = remarks;
    }
  
    this.api.apiCall(this.endPoint, 'POST', this.payload).subscribe({
      next: (response: any) => {
        if (response.Data) {
          this.dialogRef.close(true); // Pass true to indicate success
        }
      },
      error: (error) => {
        console.error('API Error:', error);
    
        // Example handling:
        // Show message or keep dialog open
        this.toastr.error(error.error.Message);
        this.dialogRef.close(false); // Pass false to indicate failure
      }
    });
  }

  cancel() {
    this.dialogRef.close(false); // Pass false to indicate cancellation
  }
}
